// extracted by css-extract-rspack-plugin
export default {"slideIn":"_96c4e37b","slideOut":"_8ae7cb52","drawer":"_9148e37c"};